import React from 'react';
import './PricingTable.css'; // Import the new CSS file

const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Changed fill color to white */}
        <path d="M8.99991 16.1698L4.82991 11.9998L3.41591 13.4138L8.99991 18.9998L20.9999 6.99984L19.5859 5.58584L8.99991 16.1698Z" fill="#FFFFFF"/>
    </svg>
);

const InfoIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8 1.33331C4.318 1.33331 1.33333 4.318 1.33333 8C1.33333 11.682 4.318 14.6666 8 14.6666C11.682 14.6666 14.6667 11.682 14.6667 8C14.6667 4.318 11.682 1.33331 8 1.33331ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM7.33333 4.66665C7.33333 4.29846 7.63181 4 8 4C8.36819 4 8.66667 4.29846 8.66667 4.66665V5.33331C8.66667 5.7015 8.36819 6 8 6C7.63181 6 7.33333 5.7015 7.33333 5.33331V4.66665ZM7.33333 7.33331C7.33333 6.96512 7.63181 6.66665 8 6.66665C8.36819 6.66665 8.66667 6.96512 8.66667 7.33331V11.3333C8.66667 11.7015 8.36819 12 8 12C7.63181 12 7.33333 11.7015 7.33333 11.3333V7.33331Z" fill="#A0A0A0"/>
    </svg>
);

const pricingData = {
  plans: ['Free', 'Pro', 'Enterprise', 'Custom'],
  categories: [
    {
      name: 'Usage',
      features: [
        { name: 'MAUs', values: ['Up to 1,000', 'Up to 100,000', 'Up to 100,000', 'Millions'], info: true },
        { name: 'Peak concurrent connections', values: ['Up to 20', '5% of MAU*', '5% of MAU*', 'Custom'] },
        { name: 'Soft caps on MAUs & peak concurrent connections', values: [false, true, true, true], info: true },
        { name: 'Messages/month', values: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'], info: true },
        { name: 'Message storage', values: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'], info: true },
        { name: 'Message retention', values: ['5 months', '6 months', '6 months', 'Request a quote'] },
        { name: 'Multiple apps under one organization', values: [true, true, true, true], info: true },
      ],
    },
    {
        name: 'Modern Messaging Essentials',
        features: [
          { name: 'Private 1-to-1 chat', values: [true, true, true, true], info: true },
          { name: 'Group channel', values: [true, true, true, true], info: true },
          { name: 'Open channel with dynamic partitioning', values: [false, true, true, true], info: true },
          { name: 'Supergroup channel', values: [true, true, true, 'Custom'], info: true },
          { name: 'UIKit', values: [true, true, true, true], info: true },
          { name: 'Typing indicators', values: [true, true, true, true], info: true },
          { name: 'Delivery receipts', values: [true, true, true, 'Custom'], info: true },
          { name: 'Read receipts', values: [true, true, true, true], info: true },
          { name: 'Presence', values: [true, true, true, true], info: true },
          { name: 'Reactions', values: [true, true, true, true], info: true },
          { name: 'Mentions', values: [true, true, true, true], info: true },
          { name: 'Unread message count', values: [true, true, true, true], info: true },
          { name: 'Push notifications', values: [true, true, true, true], info: true },
          { name: 'Share files and multimedia', values: [true, true, true, true], info: true },
          { name: 'Structured messages', values: [true, true, true, true], info: true },
          { name: 'Auto-thumbnail generator', values: [true, true, true, true], info: true },
        ],
      },
      {
        name: 'Advanced Messaging',
        features: [
          { name: 'Offline messaging', values: [true, true, true, true], info: true },
          { name: 'Smart throttling', values: [false, true, true, true], info: true },
          { name: 'Do-not-disturb push', values: [true, true, true, true], info: true },
          { name: 'Meta-array API', values: [true, true, true, 'Custom'], info: true },
          { name: 'Message threading', values: [true, true, true, true], info: true },
          { name: 'Message search', values: [true, true, true, '+'], info: true },
          { name: 'User and channel search', values: [false, true, true, true], info: true },
          { name: 'Announcements', values: [true, true, true, '+'], info: true },
          { name: 'Pinned messages', values: [false, true, true, true], info: true },
          { name: 'Scheduled messages', values: [true, true, true, true], info: true },
          { name: 'Polls', values: [true, true, true, true], info: true },
        ],
      },
      {
        name: 'Moderation',
        features: [
          { name: 'User reporting API', values: [true, true, true, '+'], info: true },
          { name: 'User-to-user blocking', values: [true, true, true, true], info: true },
          { name: 'Mute user', values: [true, true, true, '+'], info: true },
          { name: 'Moderation dashboard', values: [true, true, true, '+'], info: true },
          { name: 'Freeze channel', values: [true, true, true, '+'], info: true },
          { name: 'AI image moderation', values: [false, false, true, '+'], info: true },
          { name: 'Profanity filter', values: [true, true, true, '+'], info: true },
          { name: 'Moderation rule engine', values: [false, false, true, '+'], info: true },
          { name: 'Moderation ticket system', values: [false, false, true, '+'], info: true },
          { name: 'Moderation logs', values: [false, false, true, '+'], info: true },
          { name: 'Moderator groups', values: [false, false, true, '+'], info: true },
          { name: 'Keyword detection', values: [false, false, true, '+'], info: true },
          { name: 'Moderated users', values: [false, false, true, '+'], info: true },
          { name: 'Moderator messages', values: [false, false, false, 'Custom'], info: true },
          { name: 'Hive moderation', values: [false, false, false, 'Custom'], info: true },
        ],
      },
      {
        name: 'Data and Analytics',
        features: [
          { name: 'Analytics dashboard', values: [true, true, true, true], info: true },
          { name: 'Advanced analytics', values: [true, false, true, 'Custom'], info: true },
          { name: 'Message retrieval API', values: [true, true, true, true], info: true },
          { name: 'Data export', values: [true, false, true, 'Custom'], info: true },
        ],
      },
      {
        name: 'Integrations',
        features: [
          { name: 'Chatbot interface', values: [true, true, true, true], info: true },
          { name: 'Post-event webhooks', values: [true, true, true, true], info: true },
          { name: 'Push notifications tester', values: [true, true, true, true], info: true },
        ],
      },
      {
        name: 'Security',
        features: [
          { name: 'SAML/SSO', values: [true, true, true, true], info: true },
          { name: 'TLS/SSL encryption', values: [true, true, true, true], info: true },
          { name: 'File encryption', values: [true, true, true, true], info: true },
          { name: 'GDPR API', values: [true, true, true, true], info: true },
          { name: 'IP whitelisting', values: [false, true, true, true], info: true },
        ],
      },
      {
        name: 'Compliance',
        features: [
            { name: 'SOC 2', values: [true, true, true, true], info: true },
            { name: 'ISO 27001', values: [true, true, true, true], info: true },
            { name: 'HIPAA/BAA', values: [false, false, 'Custom', 'Custom'], info: true },
        ]
      },
      {
        name: 'Infrastructure',
        features: [
          { name: 'Choose your AWS region', values: [true, true, true, true], info: true },
          { name: 'Private dedicated servers', values: [false, false, false, 'Custom'], info: true },
          { name: 'Private status page', values: [false, false, false, 'Custom'], info: true },
          { name: 'Public static IP', values: [false, false, false, true], info: true },
        ],
      },
      {
        name: 'Support',
        features: [
          { name: 'Recommended', values: [false, 'Base or Silver', 'Base or Silver', 'Gold or Platinum'] },
          { name: 'Community support', values: [true, false, false, false] },
          { name: 'Ticket support availability', values: [false, '8x5', '8x5', '24x7'] },
          { name: 'Guaranteed response time', values: [false, 'See support page', 'See support page', 'See support page'] },
          { name: 'API status page', values: [true, true, true, true] },
          { name: 'Emergency hotline', values: [false, false, false, true] },
          { name: 'Slack support', values: [false, false, false, 'Included in Platinum'] },
          { name: 'Customer success manager', values: [false, '+', '+', '$50k in ARR'] },
          { name: 'Onboarding package', values: [false, false, false, true] },
        ],
      },
  ],
};

const renderValue = (value) => {
    if (typeof value === 'boolean') {
        // Wrap the CheckIcon in a span for styling, or return a dash
        return value ? <span className="check-icon-container"><CheckIcon /></span> : '-';
    }
    if (value === '+') {
        return <span className="plus-sign">+</span>;
    }
    return value;
}

const PricingTable = () => {
    return (
        <div className="pricing-container">
            <header className="pricing-header">
                <h1>Compare features</h1>
            </header>
            <table className="pricing-table">
                <thead>
                    <tr>
                        <th style={{ width: '34%' }}></th>
                        {pricingData.plans.map((plan, index) => (
                            <th key={index} style={{ width: '16.5%' }}>{plan}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {pricingData.categories.map((category, catIndex) => (
                        <React.Fragment key={catIndex}>
                            <tr className="category-header-row">
                                <td colSpan={pricingData.plans.length + 1}>
                                    {category.name}
                                </td>
                            </tr>
                            {category.features.map((feature, featIndex) => (
                                <tr key={featIndex}>
                                    <td className="feature-name-cell">
                                        <div className="feature-name-wrapper">
                                            <span>{feature.name}</span>
                                            {feature.info && <InfoIcon />}
                                        </div>
                                    </td>
                                    {feature.values.map((value, valIndex) => (
                                        <td key={valIndex} data-label={pricingData.plans[valIndex]}>
                                            <div className="plan-cell-content">
                                               {renderValue(value)}
                                            </div>
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </React.Fragment>
                    ))}
                    <tr className="pricing-notes">
                        <td colSpan={pricingData.plans.length + 1}>
                            *Usage per website or mobile app. Overages may apply.
                            <br />
                            <span className="note-symbol">✓</span>: Included
                            <br />
                            <span className="note-symbol">+</span>: Included and more available for additional fee
                            <br />
                            Custom: Available as an Add-on
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PricingTable;